import React from 'react';
import { useIntl } from 'react-intl';
import { Grid, Hidden } from '@mui/material';
import * as css from './welcome.module.scss';
import SiktLogo from './siktLogo';
import { useQuery } from '../api/useQuery';
import { useSetDocumentTitle } from '../api/useSetDocumentTitle';
import translations from './welcome.i18n';
import { BottomLinks, DesktopPageTop, SmallPageTop } from './commoncomponents';
import SrOnly from '../components/screenReader/screenReader';
import Button from '../components/button';

const WelcomePage = () => {
  const { pageTitle } = useLabels();
  useSetDocumentTitle(pageTitle);

  return (
    <div className={css.page}>
      <Hidden only={['md', 'lg', 'xl']}>
        <WelcomePageSmall />
      </Hidden>
      <Hidden only={['xs', 'sm']}>
        <WelcomePageDesktop />
      </Hidden>

      <footer>
        <div className={css.space50} />
        <Grid container>
          <Grid item xs={1} />
          <Grid item xs={10}>
            <SiktLogo />
          </Grid>
          <Grid item xs={1} />
        </Grid>
        <BottomLinks css={css} />
      </footer>
    </div>
  );
};

const useLabels = () => {
  const { formatMessage } = useIntl();
  return {
    pageTitle: formatMessage({ id: translations.pageTitle.id }),
    title: formatMessage({ id: translations.title.id }),
    description: formatMessage({ id: translations.description.id }),
    feide1: formatMessage({ id: translations.feide1.id }),
    feide2: formatMessage({ id: translations.feide2.id }),
    idporten1: formatMessage({ id: translations.idporten1.id }),
    idporten2: formatMessage({ id: translations.idporten2.id }),
    loggedOutMsg: formatMessage({ id: translations.loggedOutMsg.id }),
    feideHelpText: formatMessage({ id: translations.feideHelpText.id }),
    idportenHelpText: formatMessage({ id: translations.idportenHelpText.id }),
  };
};

const WelcomePageSmall = () => {
  const labels = useLabels();
  const query = useQuery();

  const onLoginFeideClick = () => {
    const returnUrl = window.location.href;
    window.location.href = `/login/login?login_hint=feide${
      returnUrl ? `&return_url=${returnUrl}` : ''
    }`;
  };

  const onLoginIdportenClick = () => {
    const returnUrl = window.location.href;
    window.location.href = `/login/login?login_hint=idporten${
      returnUrl ? `&return_url=${returnUrl}` : ''
    }`;
  };

  return (
    <div className={css.smallPage}>
      <SmallPageTop
        css={css}
        title={labels.title}
        description={labels.description}
        loggedOutMessage={query.get('loggedOut') ? labels.loggedOutMsg : ''}
      />

      <main className={css.contentContainer}>
        <div
          className={
            css.contentContainer
          } /* TODO Remove this element, when refactoring file */
        >
          <SrOnly>
            <h1>{labels.pageTitle}</h1>
          </SrOnly>
          <Button.Secondary
            className={css.centeredButton}
            onClick={onLoginFeideClick}
            data-cy={'loginFeide'}
          >
            {labels.feide1}
          </Button.Secondary>
          <div className={css.space15} />
          <p>{labels.feideHelpText}</p>
          <div className={css.space24} />

          <Button.Secondary
            className={css.centeredButton}
            onClick={onLoginIdportenClick}
            data-cy={'loginIdPorten'}
          >
            {labels.idporten1}
          </Button.Secondary>
          <p>{labels.idportenHelpText}</p>
          <div className={css.space24} />
          <div className={css.space100} />

          <div className={css.textLeft}>
            <p>{labels.feide2}</p>
            <p>{labels.idporten2}</p>
          </div>
        </div>
      </main>
    </div>
  );
};

const WelcomePageDesktop = () => {
  const labels = useLabels();
  const query = useQuery();

  const onLoginFeideClick = () => {
    const returnUrl = window.location.href;
    window.location.href = `/login/login?login_hint=feide${
      returnUrl ? `&return_url=${returnUrl}` : ''
    }`;
  };

  const onLoginIdportenClick = () => {
    const returnUrl = window.location.href;
    window.location.href = `/login/login?login_hint=idporten${
      returnUrl ? `&return_url=${returnUrl}` : ''
    }`;
  };

  return (
    <div className={css.desktop}>
      <DesktopPageTop
        css={css}
        title={labels.title}
        description={labels.description}
        loggedOutMessage={query.get('loggedOut') ? labels.loggedOutMsg : ''}
      />

      <main className={css.contentContainer}>
        <div
          className={
            css.contentContainer
          } /* TODO Remove this element, when refactoring file */
        >
          <SrOnly>
            <h1>{labels.pageTitle}</h1>
          </SrOnly>
          <div className={css.space50} />
          <div className={css.loginBtnContainer}>
            <div className={css.btnWithHelpText}>
              <Button.Secondary
                onClick={onLoginFeideClick}
                data-cy={'loginFeide'}
              >
                {labels.feide1}
              </Button.Secondary>
              <p className={css.helpText}>{labels.feideHelpText}</p>
            </div>
            <div className={css.btnWithHelpText}>
              <Button.Secondary
                onClick={onLoginIdportenClick}
                data-cy={'loginIdPorten'}
              >
                {labels.idporten1}
              </Button.Secondary>
              <p className={css.helpText}>{labels.idportenHelpText}</p>
            </div>
          </div>

          <div className={css.space100} />

          <p>{labels.feide2}</p>
          <p>{labels.idporten2}</p>
        </div>
      </main>
    </div>
  );
};

export default WelcomePage;
